import { Component, inject, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FlowbiteService } from '../shared/services/flowbite.service';
import { LucideAngularModule } from 'lucide-angular';
import { ActivatedRoute } from '@angular/router';
import { LargeSidebarComponent } from './sidebar/large-sidebar/large-sidebar.component';
import { SmallSidebarComponent } from './sidebar/small-sidebar/small-sidebar.component';
import { UserDataService } from '../shared/services/auth/userData.service';
import { filter, map, Subscription } from 'rxjs';
import { NsideIdentityService } from '../shared/services/auth/nSideIdentityService';
import { UsersnapComponent } from './components/usersnap/usersnap.component';
declare var initFlowbite: any;
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    LucideAngularModule,
    LargeSidebarComponent,
    SmallSidebarComponent,
    UsersnapComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'REMs-EOP';
  userId: string | null = null;
  buildingId: string | null = null;
  sidebarStatus: string = '';
  showSidebar = true;
  private subscriptions: Subscription = new Subscription();
  private readonly activatedRoute = inject(ActivatedRoute);

  showUsersnapWidget = true;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private flowbiteService: FlowbiteService,
    private router: Router,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.flowbiteService.loadFlowbite((flowbite) => {});

    // Sidebar visibility control
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let currentRoute = this.activatedRoute.root;
          while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
          }
          return currentRoute;
        }),
        map((route) => route.snapshot.data)
      )
      .subscribe((data) => {
        this.showSidebar = data['showSidebar'] !== false; // Set sidebar visibility based on route data
      });

    if (isPlatformBrowser(this.platformId)) {
      const usersnapHidden = localStorage.getItem('usersnapWidgetHidden');
      this.showUsersnapWidget = usersnapHidden !== 'true';

      // Retrieve sidebar status from session storage
      const savedSidebarStatus = sessionStorage.getItem('sidebarStatus');
      this.sidebarStatus = savedSidebarStatus ? savedSidebarStatus : 'large';

      // Delay the Flowbite initialization to ensure the DOM is ready
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          setTimeout(() => {
            initFlowbite();
          }, 100);
        });

      this.activatedRoute.paramMap.subscribe((params) => {
        const buildingId = params.get('buildingId');
        if (buildingId) {
          this.userDataService.setBuildingId(buildingId);
        }
      });
    }
  }

  toggleSidebarStatus(status: string): void {
    this.sidebarStatus = status;
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('sidebarStatus', status);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe(); // Unsubscribe from all subscriptions
  }
}
